import i18n from '../../locales/index'
import restful from '@/store/vuex'

const state = {
  ...restful.states('shop_charge')
}

const getters = {
  ...restful.getters('shop_charge')
}

const actions = {
  ...restful.actions('shop_charges')
}

const mutations = {
  ...restful.mutations('shop_charge')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
